document.addEventListener("DOMContentLoaded", function () {
  const swiperContainer = document.querySelector(".custom-announcement-bar-swiper-container")
  if (swiperContainer) {
    const autoplay = document.querySelector("[data-autoplay]").getAttribute("data-autoplay")
    const autoplaySpeed = document.querySelector("[data-autoplay-speed]").getAttribute("data-autoplay-speed")
    new Swiper(swiperContainer, {
      loop: true,
      speed: 500,
      autoplay: {
        enabled: autoplay,
        delay: autoplaySpeed,
        disableOnInteraction: false,
      },
    })
  }
})